module.exports = __webpack_public_path__ + "static/media/03-1-galeria-03-balenciaga@2x.84eac4c1.jpg";